var o=function(){return"function"==typeof Symbol&&Symbol.observable||"@@observable"}();export{o as observable};
